import { breakpoints } from "iparque-components";
import { ANIMATION_DURATION } from "components/Message/configs";
import Success from "components/Message/Success";
import styled from "styled-components";
import { fadeIn } from "theme/animations";

interface ContainerProps {
  isFormVisible: boolean;
}

interface SuccessProps {
  isVisible: boolean;
}

export const Container = styled.div<ContainerProps>`
  z-index: ${({ isFormVisible }) => (isFormVisible ? -1 : 1)};
  min-width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: ${breakpoints.md}) {
    min-width: unset;
  }
`;

export const StyledSuccess = styled(Success)<SuccessProps>`
  position: ${({ isVisible }) => (isVisible ? "relative" : "absolute")};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity ${ANIMATION_DURATION};
  animation: ${fadeIn} ${ANIMATION_DURATION};
  display: flex;
  flex-direction: column;
  align-items: center;
`;
